import { useEffect, useState } from 'react'
import {
  useComfeSettings,
  useDispatch,
  useHasBilling,
  useSettings,
  useShippingAddress,
  useSignupSession,
  useTaxpayerDetails,
  useUserLocale
} from '../hooks'
import { updateSignupSession } from '../actions'
import { shouldShowAddTaxId } from '../lib/taxIdHelpers'

export const useShowMissingPhoneModal = (options?: {
  onlyRequiredFieldsForTaxId?: boolean
}) => {
  const { onlyRequiredFieldsForTaxId = true } = options || {}
  const shippingAddress = useShippingAddress()
  const {
    data: { enableMissingPhoneModal, enableMissingInfoModal } = {}
  } = useSettings()

  const taxpayerDetailsState = useTaxpayerDetails()
  const userLocale = useUserLocale()
  const hasBilling = useHasBilling()
  const comfeSettingsState = useComfeSettings()

  const { showMissingPhoneModal } = useSignupSession()
  const dispatch = useDispatch()

  const [showMissingPhoneNumber, setShowMissingPhoneNumber] = useState(false)
  const [showMissingTaxId, setShowMissingTaxId] = useState(false)

  useEffect(() => {
    const shouldShowTaxId = () => {
      const shouldShow = shouldShowAddTaxId(
        hasBilling,
        taxpayerDetailsState.data,
        comfeSettingsState.data,
        userLocale.country,
        onlyRequiredFieldsForTaxId
      )
      setShowMissingTaxId(shouldShow)
      return shouldShow
    }

    const shouldShowPhoneNumber = () => {
      const shouldShow =
        !shippingAddress.data?.phoneNumber1 && !!shippingAddress.data?.street1

      setShowMissingPhoneNumber(shouldShow)
      return shouldShow
    }

    const showPhoneNumeber = shouldShowPhoneNumber()
    const showTaxId = shouldShowTaxId()

    let newState = false

    if (enableMissingPhoneModal && !enableMissingInfoModal) {
      newState = showPhoneNumeber
    } else {
      newState = enableMissingInfoModal && (showPhoneNumeber || showTaxId)
    }

    if (shippingAddress.loading || taxpayerDetailsState.loading) {
      newState = false
    }

    ;(async () => {
      await dispatch(
        updateSignupSession({
          showMissingPhoneModal: newState
        })
      )
    })()
  }, [
    comfeSettingsState.data,
    dispatch,
    enableMissingInfoModal,
    enableMissingPhoneModal,
    hasBilling,
    onlyRequiredFieldsForTaxId,
    shippingAddress.data,
    shippingAddress.loading,
    shippingAddress.data?.phoneNumber1,
    shippingAddress.data?.street1,
    taxpayerDetailsState.data,
    taxpayerDetailsState.loading,
    userLocale.country
  ])

  return {
    showMissingPhoneModal,
    showMissingPhoneNumber,
    showMissingTaxId
  }
}
